import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
import { arrow, useFloating, flip, shift, offset } from '@floating-ui/vue'
import { useFieldView } from '../FieldViewState'
import { useMap } from '../mapbox/context'
import { Point } from 'geojson'
import LocationHover from './LocationHover.vue'
import ResourceHover from './ResourceHover.vue'
import { debounce } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldViewHoverPopup',
  setup(__props) {

const reference = ref<any>(null)
const floating = ref(null)
const floatingArrow = ref(null)

const { fieldViewState, setHoveredFeature } = useFieldView()
const { map } = useMap()

const HOVER_DELAY = 1000

const open = ref<boolean>()

const middleware = ref([
  offset(18),
  flip(),
  shift(),
  arrow({ element: floatingArrow }),
])

const { floatingStyles, placement, middlewareData } = useFloating(
  reference,
  floating,
  {
    middleware,
    open,
    placement: 'right',
  }
)

const staticSide = computed<string>(
  () =>
    ({
      top: 'bottom',
      right: 'left',
      bottom: 'top',
      left: 'right',
    }[placement.value.split('-')[0]] || '')
)

const showHoverPopup = debounce(() => {
  open.value = true
}, HOVER_DELAY)

const hideHoverPopup = () => {
  open.value = false
}

const shouldShowHover = computed(
  () => open.value && (isLocation.value || isResource.value)
)

onMounted(() => {
  map.value.on('move', () => {
    if (fieldViewState.value.hoveredFeature) {
      setHoveredFeature(null)
    }
  })
})

watch(
  () => fieldViewState.value.hoveredFeature,
  () => {
    const feature = fieldViewState.value.hoveredFeature

    if (feature) {
      const point = feature.geometry as Point
      const { x: pointX, y: pointY } = map.value.project(
        point.coordinates as [number, number]
      )
      const mapElement = map.value.getContainer().getBoundingClientRect()
      const x = mapElement.x + pointX
      const y = mapElement.y + pointY

      reference.value = {
        getBoundingClientRect() {
          return {
            x,
            y,
            top: y,
            left: x,
            right: x,
            bottom: y,
            width: 0,
            height: 0,
          }
        },
      }
      showHoverPopup()
    } else {
      hideHoverPopup()
    }
  }
)

const isLocation = computed(
  () => (fieldViewState.value.hoveredFeature as any)?.source === 'locations'
)

const isResource = computed(
  () => (fieldViewState.value.hoveredFeature as any)?.source === 'resources'
)

return { __sfc: true,reference, floating, floatingArrow, fieldViewState, setHoveredFeature, map, HOVER_DELAY, open, middleware, floatingStyles, placement, middlewareData, staticSide, showHoverPopup, hideHoverPopup, shouldShowHover, isLocation, isResource, LocationHover, ResourceHover }
}

})